module.exports = __webpack_public_path__ + "static/media/logo_full_light.1268293d.png";